// extracted by mini-css-extract-plugin
module.exports = {"alert":"jI+1UH","content":"UPOf93","scroller":"XL36NS","title":"uWMQLQ","text":"XeEANe","buttons":"sHzrJL","button":"CpxaRv","secondary":"U7DWRz"};